import { TOGGLE_DEBUG_MODE } from '../actions'
import { createToggleReducer } from '../../../utility/state'

/**
 * @typedef {boolean} DebuggingState Whether debug mode is active
 */

/**
 * @param {DebuggingState} initialState
 * @returns {(state: DebuggingState, action: Object) => DebuggingState}
 */
export default function debuggingReducer(initialState) {
    return createToggleReducer(initialState, TOGGLE_DEBUG_MODE)
}
